import React from 'react';

interface EvaluationStatsHeaderProps {
  userCategory: string;
  totalSubmissions: number;
  notStarted: number;
  drafts: number;
  completed: number;
}

// Header with Statistics
const EvaluationStatsHeader: React.FC<EvaluationStatsHeaderProps> = ({
  userCategory,
  totalSubmissions,
  notStarted,
  drafts,
  completed,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-baijamjuree font-extrabold text-black mb-2">
            Overview
          </h2>
          <p className="text-gray-600 font-baijamjuree">
            Category:{' '}
            <span className="font-semibold text-gray-900">{userCategory}</span>
          </p>
        </div>

        {/* Statistics Cards */}
        <div className="flex flex-wrap gap-3">
          <div className="bg-gray-50 rounded-lg px-4 py-2 text-center w-28">
            <div className="text-2xl font-bold text-gray-900 font-baijamjuree">
              {totalSubmissions}
            </div>
            <div className="text-xs text-gray-600 font-baijamjuree uppercase tracking-wide">
              Total
            </div>
          </div>
          <div className="bg-red-50 rounded-lg px-4 py-2 text-center w-28">
            <div className="text-2xl font-bold text-red-700 font-baijamjuree">
              {notStarted}
            </div>
            <div className="text-xs text-red-600 font-baijamjuree uppercase tracking-wide">
              Pending
            </div>
          </div>
          <div className="bg-yellow-50 rounded-lg px-4 py-2 text-center w-28">
            <div className="text-2xl font-bold text-yellow-700 font-baijamjuree">
              {drafts}
            </div>
            <div className="text-xs text-yellow-600 font-baijamjuree uppercase tracking-wide">
              Drafts
            </div>
          </div>
          <div className="bg-green-50 rounded-lg px-4 py-2 text-center w-28">
            <div className="text-2xl font-bold text-green-700 font-baijamjuree">
              {completed}
            </div>
            <div className="text-xs text-green-600 font-baijamjuree uppercase tracking-wide">
              Completed
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvaluationStatsHeader;
